module.exports = __webpack_public_path__ + "img/servers-count.a3b017e8.svg";